export default __webpack_public_path__ + "static/media/(52).019ff131.jpg";